import LoadingButton from '@mui/lab/LoadingButton'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogContentText from '@mui/material/DialogContentText'
import DialogTitle from '@mui/material/DialogTitle'
import { useDeleteCampaignMutation } from '../slice'

const DeleteCampaign = ({ campaign, open, setOpen }) => {
  const [deleteCampaign, { isLoading }] = useDeleteCampaignMutation()

  const handleClose = () => {
    setOpen(false)
  }

  const handleDelete = async () => {
    await deleteCampaign(campaign.id)
    setOpen(false)
  }

  return (
    <Dialog open={open} onClose={handleClose}>
      <DialogTitle>{`Delete ${campaign?.name || 'Campaign'}?`}</DialogTitle>
      <DialogContent dividers>
        <DialogContentText>
          Deleting a campaign is irreversible. Please do not proceed unless you are sure you want to permanently delete
          it.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <LoadingButton disabled={isLoading} onClick={handleClose} autoFocus>
          Cancel
        </LoadingButton>
        <LoadingButton color="error" loading={isLoading} onClick={handleDelete}>
          Delete
        </LoadingButton>
      </DialogActions>
    </Dialog>
  )
}

export default DeleteCampaign
